import {
  buildNormalizedDay,
  buildNormalizedPilotBlueprint,
  localizedGenderNode,
} from "./referenceNormalizerPilotUtils";

/** Required substring for scripts/validate_dna_blueprints.mjs (runtime writing steps). */
export const DNA_VALIDATE_WRITING_PHRASE = "אני שואל/ת את עצמי בשקט";

const days = [
  {
    dayNumber: 1,
    emotionalStage: "pause",
    title: "Notice the wish to be seen",
    opening: localizedGenderNode(
      [
      "Today I don't try to explain.",
      "I just notice the wish to be seen.",
      "That is enough for now."
    ],
      [
      "Today I don't try to explain.",
      "I just notice the wish to be seen.",
      "That is enough for now."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause with myself.",
      "One breath."
    ],
      [
      "I pause with myself.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When do I feel others don't really know me?",
      "What in me doesn't get space there?",
      "How does it feel in my body?"
    ],
      [
      "When do I feel others don't really know me?",
      "What in me doesn't get space there?",
      "How does it feel in my body?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Noticing the wish to be seen is already a connection."
    ],
      [
      "Noticing the wish to be seen is already a connection."
    ]
    ),
    action: localizedGenderNode(
      "one breath with the words \"I am here\".",
      "one breath with the words \"I am here\"."
    ),
  },
  {
    dayNumber: 2,
    emotionalStage: "pain",
    title: "What I don't show",
    opening: localizedGenderNode(
      [
      "Today I check what I keep inside.",
      "Not to change.",
      "Just to see."
    ],
      [
      "Today I check what I keep inside.",
      "Not to change.",
      "Just to see."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my chest."
    ],
      [
      "I breathe slowly.",
      "I feel my chest."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I hide from close people?",
      "Why do I keep it to myself?",
      "What am I afraid will happen if they see?"
    ],
      [
      "What do I hide from close people?",
      "Why do I keep it to myself?",
      "What am I afraid will happen if they see?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Keeping doesn't mean there is no truth in me."
    ],
      [
      "Keeping doesn't mean there is no truth in me."
    ]
    ),
    action: localizedGenderNode(
      "write one truth to myself.",
      "write one truth to myself."
    ),
  },
  {
    dayNumber: 3,
    emotionalStage: "pain",
    title: "Moments when I was seen",
    opening: localizedGenderNode(
      [
      "Today I remember moments when I was seen.",
      "Even if few.",
      "They exist."
    ],
      [
      "Today I remember moments when I was seen.",
      "Even if few.",
      "They exist."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "When did I feel someone truly saw me?",
      "What was different there?",
      "What did it do inside me?"
    ],
      [
      "When did I feel someone truly saw me?",
      "What was different there?",
      "What did it do inside me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Even a small moment of being seen warms."
    ],
      [
      "Even a small moment of being seen warms."
    ]
    ),
    action: localizedGenderNode(
      "remember one such moment.",
      "remember one such moment."
    ),
  },
  {
    dayNumber: 4,
    emotionalStage: "pattern",
    title: "What I am looking for",
    opening: localizedGenderNode(
      [
      "Today I ask what I am looking for in connection.",
      "Not a demand.",
      "Just a need."
    ],
      [
      "Today I ask what I am looking for in connection.",
      "Not a demand.",
      "Just a need."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my belly."
    ],
      [
      "I breathe slowly.",
      "I feel my belly."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What do I need to feel known?",
      "What is missing there?",
      "What would I like to ask for gently?"
    ],
      [
      "What do I need to feel known?",
      "What is missing there?",
      "What would I like to ask for gently?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A clear need softens the heart."
    ],
      [
      "A clear need softens the heart."
    ]
    ),
    action: localizedGenderNode(
      "write one need in a word.",
      "write one need in a word."
    ),
  },
  {
    dayNumber: 5,
    emotionalStage: "pattern",
    title: "The fear that holds me",
    opening: localizedGenderNode(
      [
      "Today I notice the fear that keeps me inside.",
      "Not to fight it.",
      "Just to see."
    ],
      [
      "Today I notice the fear that keeps me inside.",
      "Not to fight it.",
      "Just to see."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What am I afraid will happen if they know me?",
      "What do I think I would lose?",
      "How does this fear protect me?"
    ],
      [
      "What am I afraid will happen if they know me?",
      "What do I think I would lose?",
      "How does this fear protect me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Sometimes fear is protection for a tender heart."
    ],
      [
      "Sometimes fear is protection for a tender heart."
    ]
    ),
    action: localizedGenderNode(
      "tell myself \"I see you\".",
      "tell myself \"I see you\"."
    ),
  },
  {
    dayNumber: 6,
    emotionalStage: "fear",
    title: "A small place to express",
    opening: localizedGenderNode(
      [
      "Today I check how to give a small place to expression.",
      "Not everything.",
      "Just a little."
    ],
      [
      "Today I check how to give a small place to expression.",
      "Not everything.",
      "Just a little."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I feel my throat."
    ],
      [
      "I breathe slowly.",
      "I feel my throat."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small part of me wants to be heard?",
      "Where could I give it a safe place?",
      "What small step can I take?"
    ],
      [
      "What small part of me wants to be heard?",
      "Where could I give it a safe place?",
      "What small step can I take?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Even a little expression changes something."
    ],
      [
      "Even a little expression changes something."
    ]
    ),
    action: localizedGenderNode(
      "write one sentence I don't say out loud.",
      "write one sentence I don't say out loud."
    ),
  },
  {
    dayNumber: 7,
    emotionalStage: "need",
    title: "Being with me among people",
    opening: localizedGenderNode(
      [
      "Today I practice staying with me even when there are people.",
      "Not disappearing.",
      "Just being."
    ],
      [
      "Today I practice staying with me even when there are people.",
      "Not disappearing.",
      "Just being."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "I feel my feet."
    ],
      [
      "I pause for a moment.",
      "I feel my feet."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What does it look like to stay with me in a conversation?",
      "What reminds me of me there?",
      "What could help me stay?"
    ],
      [
      "What does it look like to stay with me in a conversation?",
      "What reminds me of me there?",
      "What could help me stay?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "Staying with me is an anchor."
    ],
      [
      "Staying with me is an anchor."
    ]
    ),
    action: localizedGenderNode(
      "a small touch on my heart when I'm with people.",
      "a small touch on my heart when I'm with people."
    ),
  },
  {
    dayNumber: 8,
    emotionalStage: "softening",
    title: "A small true connection",
    opening: localizedGenderNode(
      [
      "Today I look for a small connection that is true.",
      "Not big.",
      "Just true."
    ],
      [
      "Today I look for a small connection that is true.",
      "Not big.",
      "Just true."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe.",
      "I am here."
    ],
      [
      "I breathe.",
      "I am here."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "With whom do I feel most true?",
      "What is there that allows truth?",
      "What small step could deepen it?"
    ],
      [
      "With whom do I feel most true?",
      "What is there that allows truth?",
      "What small step could deepen it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small truth can shift closeness."
    ],
      [
      "A small truth can shift closeness."
    ]
    ),
    action: localizedGenderNode(
      "remember one person who feels close.",
      "remember one person who feels close."
    ),
  },
  {
    dayNumber: 9,
    emotionalStage: "softening",
    title: "Daring a little",
    opening: localizedGenderNode(
      [
      "Today I check what it is like to dare a little.",
      "Not much.",
      "Just a small step."
    ],
      [
      "Today I check what it is like to dare a little.",
      "Not much.",
      "Just a small step."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small step am I afraid to take?",
      "What is the smallest safe thing?",
      "How will it feel after?"
    ],
      [
      "What small step am I afraid to take?",
      "What is the smallest safe thing?",
      "How will it feel after?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small courage is enough for today."
    ],
      [
      "A small courage is enough for today."
    ]
    ),
    action: localizedGenderNode(
      "choose a small step and remember it.",
      "choose a small step and remember it."
    ),
  },
  {
    dayNumber: 10,
    emotionalStage: "perspective",
    title: "Asking for recognition",
    opening: localizedGenderNode(
      [
      "Today I check how to ask for recognition gently.",
      "No drama.",
      "Just a word."
    ],
      [
      "Today I check how to ask for recognition gently.",
      "No drama.",
      "Just a word."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe.",
      "I am here."
    ],
      [
      "I breathe.",
      "I am here."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What would I want someone to know about me?",
      "How can I say it gently?",
      "What small thing am I willing to share?"
    ],
      [
      "What would I want someone to know about me?",
      "How can I say it gently?",
      "What small thing am I willing to share?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small share creates a crack in the wall."
    ],
      [
      "A small share creates a crack in the wall."
    ]
    ),
    action: localizedGenderNode(
      "write one sentence I would like to share.",
      "write one sentence I would like to share."
    ),
  },
  {
    dayNumber: 11,
    emotionalStage: "strength",
    title: "Someone who knows me a little",
    opening: localizedGenderNode(
      [
      "Today I notice who might know me a little.",
      "It doesn't have to be much.",
      "Just a little."
    ],
      [
      "Today I notice who might know me a little.",
      "It doesn't have to be much.",
      "Just a little."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "Who knows something real about me?",
      "What do they know about me?",
      "How does it feel to know there is someone like that?"
    ],
      [
      "Who knows something real about me?",
      "What do they know about me?",
      "How does it feel to know there is someone like that?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A little recognition still counts."
    ],
      [
      "A little recognition still counts."
    ]
    ),
    action: localizedGenderNode(
      "hold that person's name in my heart.",
      "hold that person's name in my heart."
    ),
  },
  {
    dayNumber: 12,
    emotionalStage: "release",
    title: "An inner voice that knows me",
    opening: localizedGenderNode(
      [
      "Today I look for an inner voice that knows me.",
      "Even if it is quiet.",
      "It is there."
    ],
      [
      "Today I look for an inner voice that knows me.",
      "Even if it is quiet.",
      "It is there."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe slowly.",
      "I give it space."
    ],
      [
      "I breathe slowly.",
      "I give it space."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What does that voice know about me?",
      "What does it tell me now?",
      "How does it feel to listen to it?"
    ],
      [
      "What does that voice know about me?",
      "What does it tell me now?",
      "How does it feel to listen to it?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "An inner voice that knows me is a home."
    ],
      [
      "An inner voice that knows me is a home."
    ]
    ),
    action: localizedGenderNode(
      "one sentence from that voice.",
      "one sentence from that voice."
    ),
  },
  {
    dayNumber: 13,
    emotionalStage: "choice",
    title: "A small step of closeness",
    opening: localizedGenderNode(
      [
      "Today I choose a small step of closeness.",
      "No drama.",
      "A small step."
    ],
      [
      "Today I choose a small step of closeness.",
      "No drama.",
      "A small step."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I pause for a moment.",
      "One breath."
    ],
      [
      "I pause for a moment.",
      "One breath."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What small step am I willing to try?",
      "What will feel safe enough?",
      "How will it protect me?"
    ],
      [
      "What small step am I willing to try?",
      "What will feel safe enough?",
      "How will it protect me?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "A small step is enough to move."
    ],
      [
      "A small step is enough to move."
    ]
    ),
    action: localizedGenderNode(
      "choose one small step and remember it.",
      "choose one small step and remember it."
    ),
  },
  {
    dayNumber: 14,
    emotionalStage: "continuation",
    title: "Return sentence",
    opening: localizedGenderNode(
      [
      "Today I choose a sentence that brings me back to feeling seen.",
      "When I close off.",
      "A small sentence."
    ],
      [
      "Today I choose a sentence that brings me back to feeling seen.",
      "When I close off.",
      "A small sentence."
    ]
    ),
    mindfulness: localizedGenderNode(
      [
      "I breathe.",
      "I am here."
    ],
      [
      "I breathe.",
      "I am here."
    ]
    ),
    prompts: localizedGenderNode(
      [
      "What did I learn about my need to be known?",
      "What is the first sign I close off?",
      "Which sentence brings me back a moment before?"
    ],
      [
      "What did I learn about my need to be known?",
      "What is the first sign I close off?",
      "Which sentence brings me back a moment before?"
    ]
    ),
    closing: localizedGenderNode(
      [
      "I can feel unseen and still stay with myself."
    ],
      [
      "I can feel unseen and still stay with myself."
    ]
    ),
    action: localizedGenderNode(
      "say the new sentence once.",
      "say the new sentence once."
    ),
  },
].map(buildNormalizedDay);

export const iHaveNoOneWhoReallyKnowsMeBlueprintEn = buildNormalizedPilotBlueprint({
  id: "i_have_no_one_who_really_knows_me_14d",
  version: "tri_locale_emit_en_v1",
  durationDays: 14,
  problemKey: "i_have_no_one_who_really_knows_me",
  category: "loneliness_belonging",
  journeyName: {
    he: "אין לי אף אחד שבאמת מכיר אותי",
    en: "I have no one who really knows me",
    es: "No tengo a nadie que de verdad me conozca",
  },
  days,
});

export default iHaveNoOneWhoReallyKnowsMeBlueprintEn;
